import { FC } from "react";
import Button from "components-redesign/Button/Button";
import { makeStyles } from "components/mui-core";
import Box from "@mui/material/Box";

const useStyles = makeStyles()({
  calendarFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 5px",
  },
  footerActionButtons: {
    fontWeight: 500,
    display: "flex",
    gap: "4px",
  },
});

interface Props {
  onClear: () => void;
  onCancel: () => void;
  onOk: () => void;
  disabledApply?: boolean;
  className?: string;
}

const DatePickerFooter: FC<Props> = ({
  onClear,
  onCancel,
  onOk,
  disabledApply,
  className,
}) => {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(classes.calendarFooter, className)}>
      <Button
        onClick={onClear}
        variant="text"
        size="small">
        Clear
      </Button>
      <Box className={classes.footerActionButtons}>
        <Button
          onClick={onCancel}
          variant="text"
          size="small">
          Cancel
        </Button>
        <Button
          onClick={onOk}
          variant="text"
          size="small"
          disabled={disabledApply}>
          Apply
        </Button>
      </Box>
    </div>
  );
};

export default DatePickerFooter;
